import { Map } from '../language/models';
import { Language } from './models';


export const defaultLanguages: Map<Language> = {
  'en': {
    languageId:  1,
    projectId:   0,
    default:     true,
    englishName: 'English',
    nativeName:  'English',
    codePage:    1252,
    charSet:     'UTF-8',
    rtl:         false,
    code:        'en',
  },
};
